// extracted by mini-css-extract-plugin
export default {"root":"styles_root__Bv35j","icon":"styles_icon__3r3Oe","error":"styles_error__mBT3B","info":"styles_info__AJlDq","success":"styles_success__AArQt","warning":"styles_warning__0F64j"};